export const tr = {
    copied: 'Kopyalandı',
    'copy-error': 'Kopyalama hatası',
    'copy-link': 'Koşulları panoya kopyala',
    'open-popup-text': 'Koşulları görüntüle',
    'popup-title': 'Yeniden pazarlama koşulları'
};
